import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAdmin } from "../context/AdminContext.jsx";

export function AdminGuard() {
  const { user, loading } = useAdmin();
  const location = useLocation();
  if (loading) return <main className="page-loader"><span /><p>Vérification de la session…</p></main>;
  if (!user) return <Navigate to="/admin/connexion" replace state={{ from: location.pathname }} />;
  return <Outlet />;
}
